import { glutenLabel, glutenLongLabel } from "../lib/glutenSummary";
import type { GlutenKind } from "../lib/types-explorer";

const STYLES: Record<GlutenKind, string> = {
  free: "bg-(--color-ok-soft)   text-(--color-ok)",
  marked: "bg-(--color-ok)        text-(--color-paper)",
  unknown: "bg-(--color-warn-soft) text-(--color-warn-ink)",
  contains: "bg-(--color-bad-soft)  text-(--color-bad)",
};

export function GlutenPill({ kind, mini = false }: { kind: GlutenKind; mini?: boolean }) {
  return (
    <span
      title={glutenLongLabel(kind)}
      className={`inline-flex items-center justify-center px-2 rounded-full font-bold uppercase tracking-[0.04em] ${
        mini ? "h-[22px] text-[10px] min-w-[54px]" : "h-[20px] text-[10px] min-w-[50px]"
      } ${STYLES[kind]}`}
    >
      {glutenLabel(kind)}
    </span>
  );
}
